var _rect, _path, _rect2, _rect3, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFailure = function SvgFailure(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.7129,
    y: 34.7393,
    width: 16.9705,
    height: 44.1233,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.3594 66.556L96.3583 66.5541L74.6371 27.4559C74.6367 27.4553 74.6364 27.4547 74.6361 27.4541C71.3151 21.4697 66.2082 17.3442 59.8941 17.3442C53.5793 17.3442 48.4719 21.4706 45.151 27.4559L23.4298 66.5541L23.4234 66.5657C20.2537 72.3182 19.5287 78.5943 22.6242 83.8804C25.7253 89.1762 31.5882 91.6071 38.1718 91.6071L81.6163 91.6071C88.1999 91.6071 94.0628 89.1762 97.164 83.8804C100.258 78.5973 99.5381 72.2856 96.3594 66.556Z",
    fill: "url(#paint0_linear_4014_49416)",
    stroke: "white",
    strokeWidth: 7.63672
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.0195,
    y: 43.1245,
    width: 5.75,
    height: 20.125,
    rx: 2.875,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.0195,
    y: 67.083,
    width: 5.75,
    height: 5.75,
    rx: 2.875,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 59.8962,
    cy: 104.818,
    rx: 37.1354,
    ry: 2.99479,
    fill: "url(#paint1_linear_4014_49416)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4014_49416",
    x1: 77.2639,
    y1: 31.1453,
    x2: 34.7379,
    y2: 86.2494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5350",
    stopOpacity: 0.61
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4014_49416",
    x1: 105.471,
    y1: 102.222,
    x2: 101.633,
    y2: 123.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFailure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "failure.568b9b90368197c6352839995e26f820.svg";